// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();

const html = $('html');
const body = $('body');
const _main = $('#main');

const responsive = 1120 < windowWidth ? false : true;
const responsiveMobile = 600 < windowWidth ? false : true;

keyOnPress = false;
_document
	.on('keydown', function () {
		keyOnPress = true;
	})
	.on('keyup', function () {
		keyOnPress = false;
	});

// 2.0 UTILITY FUNCTIONS
const initForms = () => {
	let inputs = $(`.field input[type="text"],
		.field input[type="email"], 
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);

	inputs
		.each(function () {
			let _this = $(this);

			if (_this.val().length > 0) {
				_this.closest('.field').addClass('has_value');
			}
		})
		.blur(function () {
			let _this = $(this);

			_this.val()
				? _this.closest('.field').addClass('has_value')
				: _this.closest('.field').removeClass('has_value');
		});
};

const download = () => {
	$('[data-action="download"]').click(function () {
		window.print();
	});
};

// 3.0 PAGE SPECIFIC FUNCTIONS

const initMenu = () => {
	let navigationA = $('.navigation a');
	let navigationOverlay = $('#navigation-overlay');
	let navigationOverlayRemove;

	if (!responsive) {
		navigationA
			.on('mouseenter focus', function () {
				let _this = $(this);

				html.addClass('menu_open');

				// if anchor tag has a corresponding image
				if (typeof _this.attr('data-image') !== 'undefined') {
					// stop clear overlay function in mouseleave();
					clearTimeout(navigationOverlayRemove);

					// find the image in #navigation-overlay, and activate it
					navigationOverlay
						.find(`[src="${_this.attr('data-image')}"]`)
						.addClass('active')
						.siblings()
						.removeClass('active');
				}
			})
			.on('mouseleave blur', function () {
				// clear all image overlay, after 600 miliseconds
				navigationOverlayRemove = setTimeout(function () {
					navigationOverlay.find('img').removeClass('active');
				}, 600);

				html.removeClass('menu_open');
			});
	}

	on('body', 'click', '.js-mobile-menu-toggle', (e) => {
		root.classList.toggle('mobile-menu-is-active');
		root.classList.contains('mobile-menu-is-active')
			? scrollDisable()
			: scrollEnable();
	});
};

const initProductFooter = () => {
	_window.click(function (e) {
		let target = $(e.target);

		// if clicked outside of dropdown
		if (
			!target.hasClass('product-purchase') &&
			!target.closest('.product-purchase').length
		) {
			// reduce dropdown
			$('.product-footer-collection .product').removeClass('package_expand');
			$('.product-purchase').removeClass('package_select_expand');
			$('.product-purchase button[type="submit"]')
				.text('Quick Shop')
				.removeClass('disabled');

			setTimeout(function () {
				// reset quantity and button data
				$('.product-purchase .package-quantity').text(1);
				$('.product-purchase input[name="quantity"]').val(1);
			}, 300);
		}
	});

	$('.comp-product-footer').each(function () {
		const productFooter = $(this);
		const variantsButton = productFooter.find(
			'.product-footer-variants button'
		);
		const collectionProduct = productFooter.find(
			'.product-footer-collection .product'
		);

		variantsButton
			.click(function () {
				let _this = $(this);
				let sizeValue = _this.attr('data-size-value');

				_this.addClass('active').siblings().removeClass('active');

				if (sizeValue == '375ml') {
					collectionProduct.find('[data-volume="large"]').addClass('inactive');
				} else {
					collectionProduct
						.find('[data-volume="large"]')
						.removeClass('inactive');
				}

				// loop through collection of products
				collectionProduct.each(function () {
					let product = $(this);

					// check if variant exists
					product.find(`[data-variant-title*="${sizeValue}"]`).length
						? // if variant exist, check matching variant input field
						  product.removeClass('inactive')
						: // if variant doesn't exist, assign inactive class
						  product.addClass('inactive');

					// hide unavailable packages
					let packages = product.find(
						'.btn[data-package-value][data-size-value]'
					);
					packages.each(function () {
						let _this = $(this);
						_this.removeClass('hidden');
						if (sizeValue != $(this).attr('data-size-value')) {
							_this.addClass('hidden');
						}
					});
					// reset any plural classes
					product.find('.package-current .package-label').removeClass('plural');
				});
			})
			.first()
			.click();

		collectionProduct.each(function () {
			const product = $(this);
			const productForm = product.find('.product-purchase');
			const productFormSubmit = product.find('button[type="submit"]');
			const productFormQuantity = product.find('[name="quantity"]');
			const productPurchaseOptions = product.find('.product-purchase-options');
			const productpackageDropdown =
				productPurchaseOptions.find('.package-dropdown');
			const productpackageDropdownBtn = productpackageDropdown.find(
				'[data-package-value]'
			);
			const productpackageDropdownLabels =
				productpackageDropdownBtn.find('.package-label');
			const productpackageCurrentLabel = productpackageDropdown.find(
				'.package-current .package-label'
			);
			const productpackageQuantity =
				productpackageDropdown.find('.package-quantity');
			const productpackageQuantityBtn =
				productPurchaseOptions.find('.btn-increment');

			productFormSubmit.click(function (e) {
				// if package is selected
				if ($(this).closest('.package_expand').length) {
					product.removeClass('package_expand');
				} else {
					// else, expand package dropdown
					e.preventDefault();
					product.addClass('package_expand');
					productpackageDropdown.find('li:not(.hidden)').first().trigger('set');
				}
			});

			const updatePriceLabel = () => {
				let selected = product.find('[data-variant-title]:checked');
				let monies =
					parseInt(selected.attr('data-variant-price')) *
					parseInt(productFormQuantity.val());

				selected.attr('data-inventory-max') > 0
					? productFormSubmit
							.text(`Add to cart — $${monies}`)
							.removeClass('disabled')
					: productFormSubmit.text('Out of Stock').addClass('disabled');
			};

			productpackageDropdown.click(function (e) {
				e.preventDefault();

				productForm.toggleClass('package_select_expand');
			});

			productpackageDropdownBtn.on('click set', function (e) {
				e.preventDefault();
				let _this = $(this);

				_this.addClass('selected').siblings().removeClass('selected');

				// get variant array based on selected size and package
				let variantSelected = product.find(
					`input[name="id"][data-variant-title="${productFooter
						.find('[data-size-value].active')
						.attr('data-size-value')} / ${productpackageDropdown
						.find('[data-package-value].selected')
						.attr('data-package-value')}"]`
				);

				// update current package label
				productpackageCurrentLabel.text(_this.find('.package-label').text());

				// check input ID for submission
				variantSelected.prop('checked', true);

				// set add to cart text and price
				productFormSubmit.text(
					`Add to cart — $${variantSelected.attr('data-variant-price')}`
				);

				// set new price label
				updatePriceLabel();
			});

			productpackageQuantityBtn.click(function (e) {
				e.preventDefault();
				let btn = $(this);
				let quantityCurrent = parseInt(productpackageQuantity.first().text());
				let quantityAdj =
					btn.hasClass('minus') && quantityCurrent > 1
						? quantityCurrent - 1
						: btn.hasClass('plus')
						? quantityCurrent + 1
						: quantityCurrent;

				productFormQuantity.val(quantityAdj);
				productpackageQuantity.text(quantityAdj);

				const pluralize = (label) => {
					if (!label.hasClass('plural')) {
						// create plural version and update label
						let newText = label.text();
						// if there is a space
						if (newText.includes(' ')) {
							let split = label.text().split(' ');
							split[0] = split[0] + 's';
							newText = split.join(' ');
						} else {
							newText = newText + 's';
						}

						label.text(newText);
						label.addClass('plural');
					}
				};

				// pluralize
				if (productFormQuantity.val() > 1) {
					pluralize(productpackageCurrentLabel);

					// iterate through dropdown
					productpackageDropdownLabels.each(function () {
						let _this = $(this);
						pluralize(_this);
					});

					// depluralize
				} else {
					let singularPackageLabel = productpackageDropdown
						.find('.selected')
						.attr('data-package-value');
					productpackageCurrentLabel.text(singularPackageLabel);
					productpackageCurrentLabel.removeClass('plural');

					// iterate through dropdown
					productpackageDropdownLabels.each(function () {
						let _this = $(this);
						let singularPackageLabel = _this
							.parent()
							.attr('data-package-value');
						_this.text(singularPackageLabel);
						_this.removeClass('plural');
					});
				}

				// set new price label
				updatePriceLabel();
			});
		});
	});
};

const initProductPurchase = () => {
	const updatePriceLabel = (target) => {
		const productPurchase = target.closest('.comp-product-purchase');
		const productFormSubmit = productPurchase.find('.add-to-cart');
		let selected = productPurchase.find('[data-variant-title]:checked');
		let monies = parseInt(selected.attr('data-price'));
		const inventory = parseInt(selected.attr('data-inventory-max'));

		inventory > 0
			? productFormSubmit.removeClass('disabled')
			: productFormSubmit.addClass('disabled');
	};

	$('.comp-product-purchase:not(.product-extra)').each(function () {
		const productPurchase = $(this);

		const sizeSelector = productPurchase.find('.product-size-variants');
		const sizeButtons = sizeSelector.find('input');

		const purchaseForm = productPurchase.find('.product-form');

		const purchaseInput = purchaseForm.find('input');

		const imageLarge =
			productPurchase.find('.variant-image[data-volume*="large"]').length > 0
				? productPurchase.find('.variant-image[data-volume*="large"]')
				: '';
		const imageSmall =
			productPurchase.find('.variant-image[data-volume*="small"]').length > 0
				? productPurchase.find('.variant-image[data-volume*="small"]')
				: '';

		const servingsLabelLarge =
			productPurchase.find('.servings-label[data-volume*="large"]').length > 0
				? productPurchase.find('.servings-label[data-volume*="large"]')
				: '';
		const servingsLabelSmall =
			productPurchase.find('.servings-label[data-volume*="small"]').length > 0
				? productPurchase.find('.servings-label[data-volume*="small"]')
				: '';

		const changeVariant = (size, package) => {
			// reset a potentially diabled add to cart button
			purchaseForm.removeClass('disabled');
			let match = false;

			purchaseInput.each(function () {
				let product = $(this);
				// match! change the variant
				if (
					product.attr('data-variant-size') == size &&
					product.attr('data-variant-package') == package
				) {
					product.prop('checked', true);
					match = true;
				}
			});

			// no match, meaning item can't be added
			if (match == false) {
				purchaseForm.addClass('disabled');
			}
		};

		sizeButtons.click(function () {
			let size = $(this).data('variant-size');
			// highlight image cases
			if (size == '375ml') {
				if (imageLarge != '' && imageSmall) {
					imageSmall.addClass('active');
					imageLarge.removeClass('active');
				}
				if (servingsLabelLarge != '') {
					servingsLabelSmall.addClass('active');
					servingsLabelLarge.removeClass('active');
				}
			} else if (size == '750ml') {
				if (imageLarge != '' && imageSmall) {
					imageLarge.addClass('active');
					imageSmall.removeClass('active');
				}
				if (servingsLabelSmall != '') {
					servingsLabelSmall.removeClass('active');
					servingsLabelLarge.addClass('active');
				}
			}
		});

		// update labeling
		currentSize = currentPackage = false;

		// event delegation to handle js-inserted html
		productPurchase.on('click', '.product-variants button', function () {
			let _this = $(this);

			// update active variant styling
			_this.addClass('active').siblings().removeClass('active');

			// get active variants
			let activeVariantSize = sizeSelector.find('[data-variant-size].active');

			// update current size input, if applicable
			if (typeof activeVariantSize.attr('data-variant-size') != 'undefined') {
				currentSize = activeVariantSize.attr('data-variant-size');
				sizeSelector.removeClass('error');
			}

			// if both size and package options are selected
			if (currentSize && currentPackage) {
				changeVariant(currentSize, currentPackage);
			}

			setTimeout(() => {
				updatePriceLabel(_this);
			}, 10);
		});

		const selectDefaults = () => {
			// select first size option
			sizeButtons.first().click();

			if (productPurchase.data('product') == 'multipack') {
				setTimeout(function () {
					productPurchase.find('button[data-variant-size="375ml"]').click();
				}, 50);
			}
		};

		setTimeout(function () {
			selectDefaults();
		}, 100);

		// listen for clicks on bottle images
		if (!productPurchase.hasClass('product-card')) {
			if (imageLarge.length > 0) {
				imageLarge.click(function () {
					sizeSelector.find('[data-variant-size*="750"]').click();
				});
			}

			if (imageSmall.length > 0) {
				imageSmall.click(function () {
					sizeSelector.find('[data-variant-size*="375"]').click();
				});
			}
		}
	});
};

const initIngredientsBlur = () => {
	if (!responsive) {
		$('.comp-featured-ingredients').each(function () {
			const ingredients = $(this).find('.featured-ingredient-wrapper');
			ingredients.mouseenter(function (e) {
				let _this = $(e.target.closest('.featured-ingredient-wrapper'));
				_this.siblings().addClass('blur');
			});
			ingredients.mouseleave(function (e) {
				ingredients.removeClass('blur');
			});
		});
	}
};

const initSyncSlider = () => {
	$('.slider-container').each(function () {
		let _this = $(this);
		let index = 0;
		let controls = _this.find('.slider-controls');
		let arrowLeft = _this.find('.slider-control-left');
		let arrowRight = _this.find('.slider-control-right');
		let maxIndex = parseInt(_this.find('.index-max').first().text());

		let previewSliderWrapper = _this.find('.preview-slider');
		let previewSlider = previewSliderWrapper.find('.slider-inner-content');
		let previewSlides = previewSliderWrapper.find('.recipe-item');
		let previewSlideWidth = previewSlides.outerWidth();
		let previewIndexLabel = previewSliderWrapper.find('.index-current-inner');
		let previewIndexHeight = previewSliderWrapper
			.find('.index-item')
			.outerHeight();
		let previewCurrPos = index * previewSlideWidth;
		let previewindexPos = index * previewIndexHeight;

		let overlaySliderWrapper = _this.find('.overlay-slider');
		let overlaySlider = overlaySliderWrapper.find('.slider-inner-content');
		let overlaySlides = overlaySliderWrapper.find('.recipe-item');
		let overlaySlideWidth = overlaySlides.outerWidth();
		let overlayIndexLabel = overlaySliderWrapper.find('.index-current-inner');
		let overlayIndexHeight = overlaySliderWrapper
			.find('.index-item')
			.outerHeight();
		let overlayCurrPos = index * overlaySlideWidth;
		let overlayindexPos = index * overlayIndexHeight;

		previewSlides.click(function (e) {
			let _this = $(e.target.closest('.recipe-item'));
			index = _this.attr('data-index');
			bookmark(index);
		});

		let bookmark = (pos) => {
			index = parseInt(pos);
			overlayCurrPos = index * overlaySlideWidth;
			overlayindexPos = index * overlayIndexHeight;
			// user translate3d for smoother browser performance
			overlaySlider.css({ transform: `translate3d(-${overlayCurrPos}px,0,0)` });
			overlayIndexLabel.css({
				transform: `translate3d(0,-${overlayindexPos}px,0)`,
			});

			// assign active state to current slide
			$(overlaySlides[index])
				.addClass('active')
				.siblings()
				.removeClass('active');

			previewCurrPos = index * previewSlideWidth;
			previewindexPos = index * previewIndexHeight;
			// user translate3d for smoother browser performance
			previewSlider.css({ transform: `translate3d(-${previewCurrPos}px,0,0)` });
			previewIndexLabel.css({
				transform: `translate3d(0,-${previewindexPos}px,0)`,
			});

			validateSlider();
		};

		let slide = (direction) => {
			direction = parseInt(direction);
			index = index + direction;
			overlayCurrPos = index * overlaySlideWidth;
			overlayindexPos = index * overlayIndexHeight;
			previewCurrPos = index * previewSlideWidth;
			previewindexPos = index * previewIndexHeight;

			// user translate3d for smoother browser performance
			overlaySlider.css({ transform: `translate3d(-${overlayCurrPos}px,0,0)` });
			overlayIndexLabel.css({
				transform: `translate3d(0,-${overlayindexPos}px,0)`,
			});
			previewSlider.css({ transform: `translate3d(-${previewCurrPos}px,0,0)` });
			previewIndexLabel.css({
				transform: `translate3d(0,-${previewindexPos}px,0)`,
			});

			// assign active state to current slide
			$(overlaySlides[index])
				.addClass('active')
				.siblings()
				.removeClass('active');

			validateSlider();
		};

		// was the click to the left or right
		controls.click(function (e) {
			// if btn is disabled, or unclickable
			if (
				e.target.classList.contains('disabled') ||
				!e.target.classList.contains('btn')
			) {
				// don't move forward with the function
				return false;
			}

			e.target.classList.contains('slider-control-right')
				? slide('1')
				: slide('-1');

			validateSlider();
		});

		if (responsive) {
			xDown = null;

			previewSliderWrapper[0].addEventListener(
				'touchstart',
				handleTouchStart,
				false
			);
			previewSliderWrapper[0].addEventListener(
				'touchmove',
				handleTouchMove,
				false
			);

			overlaySliderWrapper[0].addEventListener(
				'touchstart',
				handleTouchStart,
				false
			);
			overlaySliderWrapper[0].addEventListener(
				'touchmove',
				handleTouchMove,
				false
			);

			function handleTouchStart(e) {
				firstTouch = (e.touches || e.originalEvent.touches)[0];
				xDown = firstTouch.clientX;
			}

			function handleTouchMove(e) {
				if (!xDown) {
					return;
				}

				xUp = e.touches[0].clientX;
				xDiff = xDown - xUp;

				if (xDiff > 5) {
					$('.modal-overlay .slider-control-right').trigger('click');
				} else if (xDiff < -5) {
					$('.modal-overlay .slider-control-left').trigger('click');
				}

				xDown = null;
			}
		}

		_window.on('keydown', function (e) {
			if (html.hasClass('modal_active')) {
				switch (e.which) {
					case 37: // left
						e.preventDefault();
						$('.modal-overlay .slider-control-left').trigger('click');
						break;

					case 39: // right
						e.preventDefault();
						$('.modal-overlay .slider-control-right').trigger('click');
						break;

					default:
						return; // exit this handler for other keys
				}
			}
		});

		// check if there are more slides to left or right
		let validateSlider = () => {
			if (index == 0) {
				arrowLeft.addClass('disabled');
			} else {
				arrowLeft.removeClass('disabled');
			}

			if (index == maxIndex - 1) {
				arrowRight.addClass('disabled');
			} else {
				arrowRight.removeClass('disabled');
			}
		};

		validateSlider();
	});
};

const initSlider = () => {
	let index = 0;
	$('.single-slider').each(function () {
		let _this = $(this);
		let slider = _this.find('.slider-inner-content');
		let slides = _this.find('.recipe-item');
		let controls = _this.find('.slider-controls');
		let arrowLeft = _this.find('.slider-control-left');
		let arrowRight = _this.find('.slider-control-right');
		// hardcoded in css
		let slideWidth = slides.outerWidth();
		let indexLabel = _this.find('.index-current-inner');
		// set in liquid
		let maxIndex = parseInt(_this.find('.index-max').text());
		let indexHeight = _this.find('.index-item').outerHeight();
		let currPos = index * slideWidth;

		// was the click to the left or right
		controls.click(function (e) {
			// if btn is disabled, or unclickable
			if (
				e.target.classList.contains('disabled') ||
				!e.target.classList.contains('btn')
			) {
				// don't move forward with the function
				return false;
			}

			e.target.classList.contains('slider-control-right')
				? slide('1')
				: slide('-1');

			validateSlider();
		});

		if (responsive) {
			xDown = null;

			_this[0].addEventListener('touchstart', handleTouchStart, false);
			_this[0].addEventListener('touchmove', handleTouchMove, false);

			function handleTouchStart(e) {
				firstTouch = (e.touches || e.originalEvent.touches)[0];
				xDown = firstTouch.clientX;
			}

			function handleTouchMove(e) {
				if (!xDown) {
					return;
				}

				xUp = e.touches[0].clientX;
				xDiff = xDown - xUp;

				if (xDiff > 5) {
					$('.modal-overlay .slider-control-right').trigger('click');
				} else if (xDiff < -5) {
					$('.modal-overlay .slider-control-left').trigger('click');
				}

				xDown = null;
			}
		}

		_window.on('keydown', function (e) {
			if (html.hasClass('modal_active')) {
				switch (e.which) {
					case 37: // left
						e.preventDefault();
						$('.modal-overlay .slider-control-left').trigger('click');
						break;

					case 39: // right
						e.preventDefault();
						$('.modal-overlay .slider-control-right').trigger('click');
						break;

					default:
						return; // exit this handler for other keys
				}
			}
		});

		let slide = (direction) => {
			direction = parseInt(direction);
			index = index + direction;
			currPos = index * slideWidth;
			indexPos = index * indexHeight;
			// user translate3d for smoother browser performance
			slider.css({ transform: `translate3d(-${currPos}px,0,0)` });

			// assign active state to current slide
			$(slides[index]).addClass('active').siblings().removeClass('active');

			indexLabel.css({ transform: `translate3d(0,-${indexPos}px,0)` });
		};

		// check if there are more slides to left or right
		let validateSlider = () => {
			if (index == 0) {
				arrowLeft.addClass('disabled');
			} else {
				arrowLeft.removeClass('disabled');
			}

			if (index == maxIndex - 1) {
				arrowRight.addClass('disabled');
			} else {
				arrowRight.removeClass('disabled');
			}
		};

		validateSlider();
	});
};

const initProductScroll = () => {
	// only on desktop
	if (!responsive) {
		// wait for assets to load, else vertical scroll calc will be wrong
		window.addEventListener('load', () => {
			setProductScroll();
		});
	}
};

const setProductScroll = () => {
	// set initial defs
	const scrollImage = $('.current-product .product-image');
	const scrollHeader = $('.product-footer-header');
	if (scrollHeader.length > 0) {
		const scrollImageBottom = scrollImage.offset().top;
		const scrollImageTop = $('.recipes-inner').offset().top;
		const scrollArea = scrollImageBottom - scrollImageTop;
		// the (usually hidden) product image which creates buffer space
		const productImage = $('.recipes-product-image');
		const buffer = windowHeight / 4;
		// calc progress out of 100% to apply other transforms
		let progress =
			(scrollY - scrollImageTop + buffer) /
			(scrollImageBottom - scrollImageTop);
		// create transform for desktop flex layout
		let translateProduct = 33 * (1 - progress);
		let transitionEnd = false;

		const productScroll = () => {
			// calc diff between translated position and original position
			let scrollDiff = Math.floor(scrollImageBottom - scrollY - buffer);
			// calc progress out of 100% to apply other transforms
			progress =
				(scrollY - scrollImageTop + buffer) /
				(scrollImageBottom - scrollImageTop);
			// create transform for desktop flex layout
			translateProduct = 33 * (1 - progress);
			// if scrollY has reached past original position, lock placement
			if (scrollY + buffer >= scrollImageBottom) {
				scrollImage.css('transform', 'translate3d(0,0,0)');
				productImage.css('flex-basis', '0');
				transitionEnd = true;
			}
			// if scrollY is within scroll range, transform
			if (
				scrollImageTop - scrollY < buffer &&
				scrollY + buffer < scrollImageBottom &&
				transitionEnd != true
			) {
				scrollImage.css({ transform: `translate3d(0,${-1 * scrollDiff}px,0)` });
				productImage.css({ 'flex-basis': `${translateProduct}%` });
			}
		};

		// set initial state
		scrollImage.css({ transform: `translate3d(0,${-1 * scrollArea}px,0)` });
		productScroll();
		_window.scroll(productScroll);
	}
};

// set all active for featured ingredients section
const initMiniMap = () => {
	let miniMapWrappers = $('.ingredient-mini-map');
	miniMapWrappers.each(function () {
		let _this = $(this);
		let x = _this.attr('data-x');
		let y = _this.attr('data-y');
		let miniMap = _this.find('.mini-map');
		miniMap.css('transform', `scale(10) translate(${x}px,${y}px)`);
	});
};

// vanilla for svg-jquery conflicts
const initDecoctionsWheel = () => {
	const decoctionsImage = document.getElementById('decoctions-wheel');

	if (decoctionsImage) {
		const overviewProducts = document.querySelectorAll('.overview-product');
		const masks = decoctionsImage.querySelectorAll('.mask');
		const mask1 = decoctionsImage.querySelector('#mask-1');
		const product1 = document.querySelector('.overview-product#mask-1');
		const mask3 = decoctionsImage.querySelector('#mask-3');
		const product3 = document.querySelector('.overview-product#mask-3');

		const buttonNext = document.querySelector(
			'#product-overview-controls .btn-next'
		);
		const buttonPrev = document.querySelector(
			'#product-overview-controls .btn-prev'
		);

		buttonNext.addEventListener('click', (e) => {
			let currIndex = parseInt(
				document
					.querySelector('.overview-product.active')
					.getAttribute('data-index')
			);
			clearActives();
			if (currIndex == 3) {
				mask1.classList.add('active');
				product1.classList.add('active');
			} else {
				let product = document.querySelector(
					`.overview-product[data-index="${currIndex + 1}"]`
				);
				let mask = decoctionsImage.querySelector('#mask-' + (currIndex + 1));
				product.classList.add('active');
				mask.classList.add('active');
			}
		});

		buttonPrev.addEventListener('click', (e) => {
			let currIndex = parseInt(
				document
					.querySelector('.overview-product.active')
					.getAttribute('data-index')
			);
			clearActives();
			if (currIndex == 1) {
				mask3.classList.add('active');
				product3.classList.add('active');
			} else {
				let product = document.querySelector(
					`.overview-product[data-index="${currIndex - 1}"]`
				);
				let mask = decoctionsImage.querySelector('#mask-' + (currIndex - 1));
				product.classList.add('active');
				mask.classList.add('active');
			}
		});

		mask1.classList.add('active');
		product1.classList.add('active');

		// text event click listeners
		overviewProducts.forEach((product) => {
			product.addEventListener('click', (e) => {
				let _this = e.target.closest('.overview-product');
				let index = _this.getAttribute('id');
				let mask = decoctionsImage.querySelector('#' + index);

				clearActives();
				_this.classList.add('active');
				mask.classList.add('active');
			});
		});

		// svg event click listeners
		masks.forEach((mask) => {
			mask.addEventListener('click', (e) => {
				let _this = e.target.closest('.mask');
				let index = _this.getAttribute('id');
				let product = document.querySelector('.overview-product#' + index);

				clearActives();
				_this.classList.add('active');
				product.classList.add('active');
			});
		});

		// reset states on click
		const clearActives = () => {
			masks.forEach((mask) => {
				mask.classList.remove('active');
			});
			overviewProducts.forEach((product) => {
				product.classList.remove('active');
			});
		};
	}
};

const initMobileSlider = () => {
	$('.comp-mobile-slider').each(function () {
		const _this = $(this);
		const sliderScroll = _this.find('.mobile-slider-scroll');
		const itemLength = sliderScroll.children().length;
		const sliderBtnLeft = _this.find('.slider-control-left');
		const sliderBtnRight = _this.find('.slider-control-right');
		const slideIncrement = responsiveMobile ? windowWidth * 1.008 : 420;

		slideScrollDisability = null;

		// disable left/right button based on scroll value
		sliderScroll.scroll(function () {
			if (slideScrollDisability !== null) {
				clearTimeout(slideScrollDisability);
			}

			slideScrollDisability = setTimeout(function () {
				sliderScroll.scrollLeft() <= 0
					? sliderBtnLeft.addClass('disabled')
					: sliderBtnLeft.removeClass('disabled');

				sliderScroll.scrollLeft() > (itemLength - 1) * windowWidth
					? sliderBtnRight.addClass('disabled')
					: sliderBtnRight.removeClass('disabled');
			}, 150);
		});

		sliderBtnLeft.click(function () {
			if (getComputedStyle(html[0]).scrollBehavior === 'smooth') {
				sliderScroll.scrollLeft(sliderScroll.scrollLeft() - slideIncrement);
			} else {
				sliderScroll.animate({
					scrollLeft: sliderScroll.scrollLeft() - slideIncrement,
				});
			}
		});

		sliderBtnRight
			.click(function () {
				if (getComputedStyle(html[0]).scrollBehavior === 'smooth') {
					sliderScroll.scrollLeft(sliderScroll.scrollLeft() + slideIncrement);
				} else {
					sliderScroll.animate({
						scrollLeft: sliderScroll.scrollLeft() + slideIncrement,
					});
				}
			})
			.click();
	});
};

const initIngredientsMap = () => {
	const worldContainer = document.getElementById('map-container-inner');
	let pinArray = [];
	for (let i = 0; i < ingredientsObject.length; i++) {
		productsArray = [];
		let pointX = ingredientsObject[i].pointX;
		let pointY = ingredientsObject[i].pointY;
		let name = ingredientsObject[i].name;
		let handle = ingredientsObject[i].handle;
		let products = ingredientsObject[i].products;
		pinArray.push({
			pointX: pointX,
			pointY: pointY,
			name: name,
			handle: handle,
			products: products,
		});
	}

	//set a recognizable starting point for mobile map
	//media query is set to max-width: 500px
	if (responsive) {
		document.getElementById('map-container').scroll(200, 250);
	}

	// if (innerWidth <= 500) {
	// 	document.getElementById('map-container').scroll(500,500);
	// }

	// new way of creating absolutely positioned ingredient objects on top of static svg map
	for (let i = pinArray.length - 1; i >= 0; i--) {
		let currentPin = pinArray[i];
		let name = currentPin.name;
		let handle = currentPin.handle;
		let productHandles = currentPin.products
			.join(0)
			.split(0)
			.map((item, i) => currentPin.products[i].productHandle)
			.join(', ');
		let productNames = currentPin.products
			.join(0)
			.split(0)
			.map((item, i) => currentPin.products[i].productTitle)
			.join(', ');
		let x = currentPin.pointX;
		let y = currentPin.pointY;
		worldContainer.innerHTML += `<div style="left:${x}%; top:${y}%;"
			class="ingredient-pin found" data-name="${name}" 
			data-handle="${handle}" data-product-handles="${productHandles}" 
			data-product-names="${productNames}"></div>`;
	}

	worldContainer.addEventListener('click', (e) => {
		let point = e.target.closest('.ingredient-pin');

		if (typeof point != 'undefined' && point != null) {
			interactMap(point, true, true);
		}
	});

	// if on desktop, animate the thumbnail
	if (!responsive) {
		let thumbnail = $('#legend-thumbnail-image');
		thumbnail.click(function () {
			if (thumbnail.attr('src').length > 0) {
				let targetScroll = $('#sourcing-grid').offset().top;
				scrollBy(0, targetScroll - scrollY);
			}
		});
	}
};

const interactMap = (point, updateLegend, updateGrid) => {
	document.getElementById('world-legend').classList.remove('inactive');
	// update legend
	const legendTop = document.querySelector('.js-legend-top');
	const legendTopInner = document.querySelector('.js-legend-top-inner');
	const legendBottom = document.querySelector('.js-legend-bottom');
	const products = document.getElementById('legend-products');
	const name = document.getElementById('legend-name');
	const origin = document.getElementById('legend-origin');
	const thumb = document.querySelector('#legend-thumbnail img');

	const pointsHandle = point.getAttribute('data-handle');
	const pointObject = ingredientsObject.find((e) => e.handle === pointsHandle);

	const productsHTML = pointObject.products
		.map((product) => {
			const handle = product.productHandle;
			const title = product.productTitle;
			return `<span class="cr-${handle}">${title}</span>`;
		})
		.join('<br>');

	resetSelectedPins();

	// activate selected
	const ingredientHandle = point.getAttribute('data-handle');
	point.classList.add('selected');

	// fire only if triggered by a pin (to prevent feedback loop)
	const timeout = responsive ? 0 : 600;
	if (updateLegend) {
		legendTopInner.setAttribute('data-animate-fadeOut', '');
		legendBottom.setAttribute('data-animate-fadeOut', '');

		setTimeout(() => {
			name.innerText = pointObject.name;
			origin.innerText = pointObject.origin;
			thumb.src = pointObject.image;
			products.innerHTML = productsHTML;
			legendBottom.innerText = pointObject.description;
			legendTop.style.height = legendTopInner.offsetHeight + 'px';
			legendTopInner.removeAttribute('data-animate-fadeOut');
			legendBottom.removeAttribute('data-animate-fadeOut');
			legendTopInner.setAttribute('data-animate-fadeIn', '');
			legendBottom.setAttribute('data-animate-fadeIn', '');
		}, timeout);
	}

	if (updateGrid) {
		// hook into grid
		document
			.querySelector(
				`#sourcing-grid-picker [data-handle="${ingredientHandle}"]`
			)
			.click();
	}
};

// reset styles of selected pin
const resetSelectedPins = () => {
	let currentSelect = document.querySelector('.ingredient-pin.selected');
	if (typeof currentSelect != 'undefined' && currentSelect != null) {
		currentSelect.classList.remove('selected');
	}
};

// update map colors via legend buttons
const updateMapColors = (product, state) => {
	let points = document.querySelectorAll(
		`.ingredient-pin[data-product-handles*="${product}"]`
	);
	points.forEach((point) => {
		if (state) {
			point.classList.add('active');
		} else {
			point.classList.remove('active');
		}
	});
};

const initIngredientsGrid = () => {
	const ingredient = $('.ingredient');
	const sourcingGridInspector = $('#sourcing-grid-inspector');
	let timeout = responsive ? 100 : 600;

	ingredient.click(function () {
		let _this = $(this);
		let ingredientData =
			ingredientsObject[
				ingredientsObject.findIndex((x) => x.name === _this.attr('data-name'))
			];

		// hook into map
		let ingredientHandle = ingredientData.handle;
		let mapIngredient = document.querySelector(
			`.ingredient-pin[data-handle="${ingredientHandle}"]`
		);
		interactMap(mapIngredient, true, false);

		history.replaceState(null, null, '#element=' + ingredientHandle);

		// resume grid update
		_this.addClass('active').siblings().removeClass('active');

		sourcingGridInspector.children().attr('data-animate-fadeOut', '');

		setTimeout(function () {
			sourcingGridInspector.html(`
				<div id="inspector-head">
					<h2 class="t-heading">${ingredientData['name']}</h2>
					<div class="t-label">${ingredientData['latinName']}</div>
				</div>
				<div id="inspector-image">
					<span class="object-contain">
						<img ${ingredientData['cover'] == 'true' ? `class="ingredient-cover"` : ''}
						src="${ingredientData['image']}"
							alt="${ingredientData['name']}">
					</span>
				</div>
				<div id="inspector-content" class="g-flex">
					<div id="inspector-content-info" class="g-flex">
						<div id="inspector-content-info-left">
							${
								ingredientData.products.length
									? `<div class="info-group">
									<div class="t-label">Decoction</div>
									<ul class="t-body">${ingredientData['products']
										.join(0)
										.split(0)
										.map(
											(item, i) =>
												`<li><a 
												href="${ingredientData['products'][i].productUrl}"
												data-location="internal"
												aria-label="Link to product">
												${ingredientData['products'][i].productTitle}
											</a></li>`
										)
										.join('')}</ul>
									</div>`
									: ''
							}
						</div>
						<div id="inspector-content-info-right">
							${
								ingredientData['origin'] != ''
									? `<div class="info-group">
									<div class="t-label">Source</div>
									<div class="t-body">${ingredientData['origin']}</div>
									</div>`
									: ''
							}
						</div>
						${
							ingredientData['description'] != ''
								? `<div id="inspector-content-info-description">
								<p>${ingredientData['description']}</p>
								</div>`
								: ''
						}
					</div>
				</div>
			`);

			sourcingGridInspector.children().attr('data-animate-fadeIn', '');
		}, timeout);
	});
};

const initFlickity = () => {
	let sliderWrapper = $('.slider-wrapper');
	//defaults
	let wrap = true;
	let drag = true;
	let autoPlay = false;
	let pauseOnHover = true;
	let buttons = false;
	let dots = sliderWrapper.hasClass('product-slider') ? true : false;
	let align = 'left';
	let adaptiveHeight = false;

	const createSlider = (
		target,
		wrap,
		drag,
		autoplay,
		pauseOnHover,
		buttons,
		dots,
		align,
		adaptiveHeight
	) => {
		target.flickity({
			wrapAround: wrap,
			draggable: drag,
			autoPlay: autoplay,
			pageDots: dots,
			pauseAutoPlayOnHover: pauseOnHover,
			prevNextButtons: buttons,
			pageDots: dots,
			cellAlign: align,
			adaptiveHeight: adaptiveHeight,
		});
	};

	if (sliderWrapper != null && typeof sliderWrapper != 'undefined') {
		sliderWrapper.each(function () {
			let _this = $(this);
			let slider = _this.find('.slider');
			let slides = _this.find('.slide');
			let prev = _this.find('.btn-prev');
			let next = _this.find('.btn-next');
			let nav = _this.find('.slider-nav-item');
			let count;

			//all-purpose slider functions
			const initSliderHelpers = () => {
				let flkty = slider.data('flickity');

				prev.on('click', () => {
					slider.flickity('previous', true, false);
				});

				next.on('click', () => {
					slider.flickity('next', true, false);
				});

				slider.on('dragStart.flickity', () =>
					slider.find('.slide').css('pointer-events', 'none')
				);
				slider.on('dragEnd.flickity', () =>
					slider.find('.slide').css('pointer-events', 'all')
				);

				nav.on('click', function () {
					let index = $(this).index();
					slider.flickity('select', index);
				});

				slider.on('change.flickity', function (event, index) {
					$(nav[index]).addClass('active').siblings().removeClass('active');
				});
			};

			createSlider(
				slider,
				wrap,
				drag,
				autoPlay,
				pauseOnHover,
				buttons,
				dots,
				align,
				adaptiveHeight
			);
			initSliderHelpers();
			_window.on('resize', () => {
				createSlider(
					slider,
					wrap,
					drag,
					autoPlay,
					pauseOnHover,
					buttons,
					dots,
					align,
					adaptiveHeight
				);
			});
		});
	}
};

const initPressSlider = () => {
	const pressSlider = $('#press-slider');
	const pressSliderQuotes = pressSlider.find('.slide');
	const pressSliderButtons = pressSlider.find('.slider-nav-item');
	const pressSliderLength = pressSliderQuotes.length;

	// select default
	if (pressSliderButtons.length % 2 == 0) {
		pressSliderButtons.first().click().addClass('active');
	} else {
		let defaultIndex = Math.floor(pressSliderButtons.length / 2);
		pressSlider
			.find(`.slider-nav-item[data-index="${defaultIndex}"]`)
			.click()
			.addClass('active');
	}
};

const initContactPage = () => {
	const faqSidebarA = $('#faq-sidebar li a');
	const faqContent = $('#faq-content');

	faqSidebarA
		.click(function (e) {
			e.preventDefault();

			let _this = $(this);
			let faqContentActive = faqContent.find(
				`#shopify-section-faq-${_this.attr('data-faq-trigger')}`
			);

			_this.parent().addClass('active').siblings().removeClass('active');

			faqContentActive.addClass('active').siblings().removeClass('active');

			faqContent.height(faqContentActive.height());
		})
		.first()
		.click();
};

const initProcessSlider = () => {
	const slider = document.getElementById('process-slider');
	if (slider) {
		const speed = parseInt(slider.getAttribute('data-speed')) * 1000;
		const slides = slider.querySelectorAll('.process-slide');
		const navItems = slider.querySelectorAll('.process-slide-nav-item');
		const count = slides.length;
		// set first as active
		slides[0].classList.add('active');

		if (count > 1) {
			const rotate = () => {
				let activeSlide = slider.querySelector('.process-slide.active');
				clearActiveSlide();
				let index = parseInt(activeSlide.getAttribute('data-index'));
				// start over or increment?
				index == count - 1 ? (index = 0) : index++;

				activateSlide(index);
			};

			const activateSlide = (index) => {
				let targetSlide = slides[index];
				targetSlide.classList.add('active');

				if (targetSlide.querySelectorAll('video').length > 0) {
					let video = targetSlide.querySelector('video');
					video.currentTime = 0;
					video.play();
				}
			};

			const clearActiveSlide = () => {
				let activeSlide = slider.querySelector('.process-slide.active');
				activeSlide.classList.remove('active');
				// if contains video, pause it
				if (activeSlide.querySelectorAll('video').length > 0) {
					let video = activeSlide.querySelector('video');
					video.pause();
				}
			};

			const assessSlide = (navItem) => {
				// if not already active
				let navIndex = navItem.getAttribute('data-index');
				let currentSlide = slides[navIndex];

				if (!currentSlide.classList.contains('active')) {
					// reset active slide
					clearActiveSlide();
					// move to clicked slide
					activateSlide(navIndex);
					// reset timer
					clearInterval(interval);
					interval = setInterval(rotate, speed);
				}
			};

			let interval = setInterval(rotate, speed);

			navItems.forEach((navItem) => {
				navItem.addEventListener('mouseover', () => {
					assessSlide(navItem);
				});
				navItem.addEventListener('focus', () => {
					assessSlide(navItem);
				});
			});
		}
	}
};

const initProcessSections = () => {
	const audio = document.getElementById('process-sound');
	const audioButton = document.getElementById('process-sound-button');
	const navButtons = document.querySelectorAll('.process-slide-nav-item');

	const audioFiles = audio.querySelectorAll('audio');
	const audio1 = document.getElementById('process-sound-1');
	const audio2 = document.getElementById('process-sound-2');
	const audio3 = document.getElementById('process-sound-3');
	const audio4 = document.getElementById('process-sound-4');

	// how far above the section should we consider to be 'in' the section
	const leeway = 30;

	// audio playback determined by section
	const section1 = document.getElementById('process-collection');
	const section2 = document.getElementById('process-post-harvest');
	const section3 = document.getElementById('process-cooking');
	const section4 = document.getElementById('process-next');
	let section1Top = section1.getBoundingClientRect().top + scrollY - leeway;
	let section2Top = section2.getBoundingClientRect().top + scrollY - leeway;
	let section3Top = section3.getBoundingClientRect().top + scrollY - leeway;
	let section4Top = section4.getBoundingClientRect().top + scrollY - leeway;

	const calcPositions = () => {
		section1Top = section1.getBoundingClientRect().top + scrollY - leeway;
		section2Top = section2.getBoundingClientRect().top + scrollY - leeway;
		section3Top = section3.getBoundingClientRect().top + scrollY - leeway;
		section4Top = section4.getBoundingClientRect().top + scrollY - leeway;
	};

	const pauseAudio = () => {
		audioFiles.forEach((file) => {
			file.pause();
			file.classList.remove('play');
		});
	};

	const clearActiveNav = () => {
		if (
			document.querySelectorAll('.process-slide-nav-item.active').length > 0
		) {
			document
				.querySelector('.process-slide-nav-item.active')
				.classList.remove('active');
		}
	};

	const setActiveNav = (index) => {
		navButtons[index].classList.add('active');
	};

	const processAudio = () => {
		// pause
		if (!audioButton.classList.contains('off')) {
			if (scrollY >= section4Top) {
				if (!audio4.classList.contains('play')) {
					pauseAudio();
					audio4.play();
					audio4.classList.add('play');
				}
			} else if (scrollY >= section3Top) {
				if (!audio3.classList.contains('play')) {
					pauseAudio();
					audio3.play();
					audio3.classList.add('play');
				}
			} else if (scrollY >= section2Top) {
				if (!audio2.classList.contains('play')) {
					pauseAudio();
					audio2.play();
					audio2.classList.add('play');
				}
			} else {
				if (!audio1.classList.contains('play')) {
					pauseAudio();
					audio1.play();
					audio1.classList.add('play');
				}
			}
		}
	};

	const processNav = () => {
		if (scrollY > section4Top) {
			clearActiveNav();
		} else if (scrollY >= section3Top) {
			if (!navButtons[3].classList.contains('active')) {
				clearActiveNav();
				setActiveNav(3);
			}
		} else if (scrollY >= section2Top) {
			if (!navButtons[2].classList.contains('active')) {
				clearActiveNav();
				setActiveNav(2);
			}
		} else if (scrollY >= section1Top) {
			if (!navButtons[1].classList.contains('active')) {
				clearActiveNav();
				setActiveNav(1);
			}
		} else {
			if (!navButtons[0].classList.contains('active')) {
				clearActiveNav();
				setActiveNav(0);
			}
		}
		scrollY > 30 ? html.addClass('scrolled') : html.removeClass('scrolled');
	};

	// (re)calc once loaded
	window.addEventListener('load', () => {
		calcPositions();
		processNav();
	});

	audioButton.addEventListener('click', () => {
		audioButton.classList.toggle('off');
		pauseAudio();
		processAudio();
	});

	window.addEventListener('scroll', () => {
		processAudio();
		processNav();
	});

	// init
	processNav();
};

const initProcessIllustration = () => {
	const slider = document.getElementById('process-illustration');
	if (slider) {
		const slides = slider.querySelectorAll('.process-illustration-image');
		const navItems = slider.querySelectorAll('.process-illustration-nav-item');
		const navButtons = slider.querySelectorAll(
			'.process-illustration-nav-button'
		);
		const speed = 6000;
		const count = slides.length;
		// set first as active
		slides[0].classList.add('active');
		navItems[0].classList.add('active');

		if (count > 1) {
			const rotate = () => {
				let activeSlide = slider.querySelector(
					'.process-illustration-image.active'
				);
				clearActiveSlide();
				let index = parseInt(activeSlide.getAttribute('data-index'));
				// start over or increment?
				index == count - 1 ? (index = 0) : index++;
				activateSlide(index);
			};

			const activateSlide = (index) => {
				slides[index].classList.add('active');
				navItems[index].classList.add('active');
			};

			const clearActiveSlide = () => {
				slider
					.querySelector('.process-illustration-image.active')
					.classList.remove('active');
				slider
					.querySelector('.process-illustration-nav-item.active')
					.classList.remove('active');
			};

			const assessSlide = (navItem) => {
				// if not already active
				let navIndex = navItem.getAttribute('data-index');
				let currentSlide = navItems[navIndex];
				if (!currentSlide.classList.contains('active')) {
					// reset active slide
					clearActiveSlide();
					// move to clicked slide
					let index = parseInt(currentSlide.getAttribute('data-index'));
					console.table({ index });
					activateSlide(index);
					// reset timer
					clearInterval(interval);
					interval = setInterval(rotate, speed);
				}
			};

			let interval = setInterval(rotate, speed);

			const stopRotation = () => {
				clearInterval(interval);
			};

			navButtons.forEach((navButton) => {
				navButton.addEventListener('click', (e) => {
					let navItem = e.target.closest('.process-illustration-nav-item');
					assessSlide(navItem);
					stopRotation();
				});
			});
		}
	}
};

const initProcessGallery = () => {
	// reset x coordinate to 0 on page load due to occasional overflow
	scrollBy(-9999, 0);
	const gallery = document.getElementById('process-gallery');
	if (gallery) {
		const gallerySlider = document.getElementById('process-gallery-slider');
		const galleryText = document.getElementById('process-gallery-text');
		const gallerySliderScroll = document.getElementById(
			'process-gallery-slider-scroll'
		);
		const gallerySliderHeight = gallerySlider.offsetHeight;
		const galleryHeight = gallery.offsetHeight - gallerySliderHeight;
		// less scroll once at the bottom
		const multiplier = 1;

		const calcPositions = () => {
			let galleryTop = gallery.getBoundingClientRect().top;
			// if the slider is at or above the top of the window
			if (galleryTop <= 0) {
				let wrapperTop = gallery.getBoundingClientRect().top;
				let progress = Math.ceil(((wrapperTop * -1) / galleryHeight) * 100);
				gallerySliderScroll.style.transform = `translateX(-${
					progress * multiplier
				}%)`;
				gallerySlider.style.position = 'fixed';
				// fade in text at 85%
				if (progress > 85) {
					galleryText.classList.add('scrolled');
				} else {
					galleryText.classList.remove('scrolled');
				}
			} else {
				gallerySlider.style.position = 'absolute';
			}

			// let scrolled = Math.abs(galleryTop);
			// if (galleryTop <= 0 && scrolled < galleryHeight) {
			// 	galleryText.style.transform = `translateY(${scrolled}px)`;
			// }
		};

		window.addEventListener('scroll', () => {
			calcPositions();
		});
	}
};

const initParallax = () => {
	const targets = document.querySelectorAll('.parallax');
	// for every x pixels scrolled, translate 1
	if (!responsive) {
		if (targets.length > 0) {
			// the position is a function of:
			// the scollY above/below the element's offset from doc top
			// data-momentum attr (integer)
			const calcPosition = () => {
				// get user's position (bottom of screen)
				let pos = scrollY + innerHeight;
				// translate image based on dampened scroll progress - initial offset
				targets.forEach((target, i) => {
					// for later: if pos is not within 2 innerHeights of the distanceFromTop, do nothing
					let distanceFromTop = target.getBoundingClientRect().top;
					// if target has a custom dampener, overwrite the default
					dampener = target.hasAttribute('data-dampener')
						? parseInt(target.getAttribute('data-dampener'))
						: 10;

					let progess = Math.floor((pos - distanceFromTop) / dampener);
					target.style.transform = `translate3d(0,${progess}px,0)`;
				});
			};

			// set initial offset
			calcPosition();
			// recalc on every scroll event
			window.addEventListener('scroll', calcPosition);
		}
	}
};

// 4.0 INIT
initMenu();
initForms();
download();
initProductPurchase();
initSyncSlider();
initSlider();
initPressSlider();
initMobileSlider();

switch (html.attr('id')) {
	case 'template-frontpage':
		initFlickity();
		initDecoctionsWheel();
		initIngredientsBlur();
		initProductFooter();
		break;

	case 'template-list-collections':
		initFlickity();
		break;

	case 'template-page-story':
		break;

	case 'template-blog-single':
		initFlickity();
		break;

	case 'template-product-index-art-of-living':
		initFlickity();
		initProductFooter();
		break;

	case 'template-product-single':
		initIngredientsBlur();
		initProductFooter();
		break;

	case 'template-product-extra':
		initProductFooter();
		break;

	case 'template-page-mixology':
		initSyncSlider();
		break;

	case 'template-page-sourcing':
		initIngredientsMap();
		initIngredientsGrid();
		break;

	case 'template-page-process':
		initProcessSlider();
		initProcessSections();
		initProcessIllustration();
		initProcessGallery();
		initParallax();
		break;

	case 'template-page-contact':
		initContactPage();
		break;
}
